import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Row, Card, Copy, Bold } from "app/NativeComponents/common";
import TabButton from "./TabButton";

import MailingAddresses from "./MailingAddresses";
import PhoneNumbers from "./PhoneNumbers";
import EmailAddresses from "./EmailAddresses";

import SkipTraceButton from "./SkipTraceButton";

import { appRedirect, updateOwnerInfo } from "app/NativeActions";

class ContactInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_owner_tab: "mailing_addresses"
    };
  }

  updateTab(selected_owner_tab) {
    if (this.state.selected_owner_tab == selected_owner_tab) {
      this.setState({
        selected_owner_tab: ""
      });
    } else {
      this.setState({
        selected_owner_tab
      });
    }
  }

  render() {
    const { active_property, owner_info, colors } = this.props;
    const { selected_owner_tab } = this.state;

    if (active_property.deal && active_property.deal.removed != 1) {
      if (owner_info.owner_name && owner_info.owner_name !== "") {
        return (
          <Wrapper>
            <Row style={{ marginBottom: -4 }}>
              <TabButton
                title="Mailing Addresses"
                icon="location-on"
                slug="mailing_addresses"
                count={
                  active_property.deal.additional_mailing_addresses_count
                    ? parseInt(
                        active_property.deal.additional_mailing_addresses_count
                      ) + 1
                    : active_property.deal.additional_mailing_addresses
                    ? parseInt(
                        active_property.deal.additional_mailing_addresses.length
                      ) + 1
                    : 1
                }
                selected_owner_tab={this.state.selected_owner_tab}
                onPress={() => this.updateTab("mailing_addresses")}
                {...this.props}
              />
              <TabButton
                title="Phone Numbers"
                icon="call"
                slug="phone_numbers"
                count={
                  active_property.deal.phone_numbers_count
                    ? active_property.deal.phone_numbers_count
                    : active_property.deal.phone_numbers
                    ? active_property.deal.phone_numbers.length
                    : 0
                }
                selected_owner_tab={this.state.selected_owner_tab}
                onPress={() => this.updateTab("phone_numbers")}
                {...this.props}
              />
              <TabButton
                title="Email Addresses"
                icon="alternate-email"
                slug="email_addresses"
                count={
                  active_property.deal.phone_numbers_count
                    ? active_property.deal.email_addresses_count
                    : active_property.deal.email_addresses
                    ? active_property.deal.email_addresses.length
                    : 0
                }
                selected_owner_tab={this.state.selected_owner_tab}
                onPress={() => this.updateTab("email_addresses")}
                {...this.props}
              />
            </Row>
            <Wrapper style={{ backgroundColor: colors.background_color }}>
              <MailingAddresses
                {...this.props}
                selected_owner_tab={this.state.selected_owner_tab}
              />
              <PhoneNumbers
                {...this.props}
                selected_owner_tab={this.state.selected_owner_tab}
              />
              <EmailAddresses
                {...this.props}
                selected_owner_tab={this.state.selected_owner_tab}
              />
              <SkipTraceButton {...this.props} />
            </Wrapper>
          </Wrapper>
        );
      }
    }
    return null;
  }
}

const mapStateToProps = ({ auth, settings, native, billing }) => {
  const { token, user } = auth;
  const { colors } = settings;
  const { device } = native;
  const { plan_modules } = billing;
  return {
    token,
    user,
    colors,
    device,
    plan_modules
  };
};

export default connect(mapStateToProps, {
  appRedirect
})(ContactInformation);
